import moment from 'moment';

export const yearFrom = 2019;

const currentYear = moment().year();
export const yearTo = currentYear;
export const diagramYearFrom = currentYear - 1;
